export default __webpack_public_path__ + "static/media/mdi_shopping.d2247e47.svg";